module.exports = __webpack_public_path__ + "img/wind_elemental_small.792ae2e4.png";